import type { PageLoad } from './$types';

export const load: PageLoad = async ({ params, fetch }) => {
	const { id, slug } = params;

	const idInt = parseInt(id);

	if (isNaN(idInt)) {
		return {
			status: 404
		};
	}

	const [gameContentResponse, gameDataResponse] = await Promise.all([
		fetch(`https://api.scratchoff-odds.com/games/${slug}`),
		fetch(`https://clj.scratchoff-odds.com/game-data/${id}`)
	]);

	if (!gameContentResponse.ok || !gameDataResponse.ok) {
		return {
			status: 500,
			error: new Error(`Failed to fetch data for game ${id}`)
		};
	}

	const gameData = await gameDataResponse.json();
	const gameContent = await gameContentResponse.json();

	// find the game in the gameContent.games array by id
	const game = gameContent.games.find((g) => g.id === idInt);

	const meta = {
		title: `${gameData.totalNumGrandPrize} Grand Prizes. ${gameData.name} - ${gameData.state} Lottery - Dr. Lotto`,
		description: `What is the best scratch off ticket to buy? See the odds and analysis for the game ${gameData.name} from the ${gameData.state} scratch off lottery.`,
		keywords: `${gameData.name}, ${gameData.state}, lotto, scratchoff, scratch off odds`
	};

	// START state image hacks. With new backend we can remove
	if (game.state === 'ca') {
		game.image_urls = game.image_urls.map((url: string) => {
			return url
				.replace('scratched-image', 'scratchedImage')
				.replace('unscratchedImage', 'unScratchedImage')
				.replace('.png', '.jpg');
		});
	}
	if (game.state === 'fl') {
		// rename .jpeg to .jpg
		game.image_urls = game.image_urls.map((url: string) => {
			return url.replace('.jpeg', '.jpg');
		});
	}

	return {
		gameData,
		game,
		meta
	};
};
